import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAvailableMaterials,
  createMaterialReservation,
  cancelMaterialReservation,
  fetchMaterialReservations,
} from "../action";
import { MaterialState } from "../types";

const initialState: MaterialState = {
  isLoading: false,
  myMaterialReservationsLoading: false,
  availableMaterials: [],
  myMaterialReservations: [],
  lastReservation: null,
  error: null,
};

export const materialSlice = createSlice({
  name: "material",
  initialState,
  reducers: {
    clearMaterials: (state) => {
      state.availableMaterials = [];
      state.lastReservation = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableMaterials.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAvailableMaterials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.availableMaterials = action.payload ?? [];
      })
      .addCase(fetchAvailableMaterials.rejected, (state, action) => {
        state.isLoading = false;
        state.availableMaterials = [];
        state.error = action.payload;
      })
      .addCase(createMaterialReservation.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createMaterialReservation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.lastReservation = action.payload;
      })
      .addCase(createMaterialReservation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(cancelMaterialReservation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(cancelMaterialReservation.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(cancelMaterialReservation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMaterialReservations.pending, (state) => {
        state.myMaterialReservationsLoading = true;
      })
      .addCase(fetchMaterialReservations.fulfilled, (state, action) => {
        state.myMaterialReservationsLoading = false;
        state.myMaterialReservations = action.payload ?? [];
      })
      .addCase(fetchMaterialReservations.rejected, (state) => {
        state.myMaterialReservationsLoading = false;
      });
  },
});

export const { clearMaterials } = materialSlice.actions;
export default materialSlice.reducer;
